import {CREATE_SAMPLING_POINT_MUTATION_KEY, createSamplingPoint} from './createSamplingPoint'
import {DELETE_SAMPLING_POINT_MUTATION_KEY, deleteSamplingPoint} from './deleteSamplingPoint'
import {
  SAVE_SAMPLING_POINTS_PINNED_SECTION_MUTATION_KEY,
  saveSamplingPointsPinnedSection
} from './saveSamplingPointsPinnedSection'
import {UPDATE_SAMPLING_POINT_MUTATION_KEY, updateSamplingPoint} from './updateSamplingPoint'

export const samplingPointsMutations = {
  [CREATE_SAMPLING_POINT_MUTATION_KEY]: createSamplingPoint,
  [UPDATE_SAMPLING_POINT_MUTATION_KEY]: updateSamplingPoint,
  [DELETE_SAMPLING_POINT_MUTATION_KEY]: deleteSamplingPoint,
  [SAVE_SAMPLING_POINTS_PINNED_SECTION_MUTATION_KEY]: saveSamplingPointsPinnedSection
}
